function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../_snowpack/pkg/react.js';

function BillingAndPayments(props) {
  const {
    width = 17,
    height = 16,
    ...rest
  } = props;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: width,
    height: height,
    viewBox: "0 0 17 16"
  }, rest, {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.977 1a.5.5 0 0 1 .5.5v12.993a.5.5 0 0 1-.5.5h-.337c-.108 0-.214-.017-.316-.051l-1.03-.344a1 1 0 0 0-.632 0l-.867.29a1 1 0 0 1-.632 0l-.867-.29a1 1 0 0 0-.632 0l-1.107.37a.5.5 0 0 1-.158.025H3.982a.5.5 0 0 1-.5-.5V1.5a.5.5 0 0 1 .5-.5H4.4a1 1 0 0 1 .164.014l1.254.209a1 1 0 0 0 .328 0l1.171-.195a1 1 0 0 1 .329 0l1.17.195a1 1 0 0 0 .33 0l1.253-.209A.999.999 0 0 1 10.562 1h3.416Z",
    fill: "#BFF6F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.027 14.493V1.5a.05.05 0 0 0-.05-.05h-3.415a.55.55 0 0 0-.09.008l-1.254.209a1.449 1.449 0 0 1-.477 0l-1.17-.195a.55.55 0 0 0-.18 0l-1.172.195a1.449 1.449 0 0 1-.476 0l-1.253-.21a.55.55 0 0 0-.09-.007h-.418a.05.05 0 0 0-.05.05v12.994c0 .028.023.05.05.05H7.4c.006 0 .011 0 .016-.002l1.106-.37c.298-.098.62-.098.917 0l.867.29a.55.55 0 0 0 .348 0l.867-.29c.298-.098.62-.098.917 0l1.029.344a.55.55 0 0 0 .174.028h.337a.05.05 0 0 0 .05-.05Zm.45-12.994a.5.5 0 0 0-.5-.5h-3.415a.999.999 0 0 0-.164.014l-1.254.209a1 1 0 0 1-.329 0l-1.17-.195a1 1 0 0 0-.329 0l-1.17.195a1 1 0 0 1-.33 0l-1.253-.209A1 1 0 0 0 4.4 1h-.417a.5.5 0 0 0-.5.5v12.993a.5.5 0 0 0 .5.5H7.4a.5.5 0 0 0 .158-.026l1.107-.369a1 1 0 0 1 .632 0l.867.29a1 1 0 0 0 .632 0l.867-.29a1 1 0 0 1 .632 0l1.03.344c.102.034.208.05.316.05h.337a.5.5 0 0 0 .5-.499V1.5Z",
    fill: "#528693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.481 9.37c0-.206.168-.374.375-.374h6.747a.375.375 0 1 1 0 .75H5.856a.375.375 0 0 1-.375-.375Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.856 8.497h6.747a.775.775 0 1 1 0 1.55H5.856a.775.775 0 0 1 0-1.55Zm0 .4a.375.375 0 1 0 0 .75h6.747a.375.375 0 1 0 0-.75H5.856Z",
    fill: "#528693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.48 11.37c0-.207.167-.375.374-.375h2.75a.375.375 0 0 1 0 .75h-2.75a.375.375 0 0 1-.374-.375Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.854 10.496h2.749a.775.775 0 1 1 0 1.55H9.854a.775.775 0 1 1 0-1.55Zm0 .4a.375.375 0 1 0 0 .75h2.749a.375.375 0 1 0 0-.75H9.854Z",
    fill: "#528693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98 4.748a1.25 1.25 0 1 1-2.499 0 1.25 1.25 0 0 1 2.5 0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.38 4.65a1.65 1.65 0 1 1-3.299 0 1.65 1.65 0 0 1 3.3 0ZM6.73 5.898a1.25 1.25 0 1 0 0-2.499 1.25 1.25 0 0 0 0 2.499Z",
    fill: "#528693"
  }));
}

export default BillingAndPayments;